/* eslint-disable  */
import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { useHistory } from "react-router-dom";
import { toast, ToastContainer } from "react-toastify";
import { bindActionCreators } from "redux";
import Loader from "../../Components/Loader";
import { authActionCreators, dataActionCreators } from "../../services/Actions";
import Modal from "../Components/Modal";
import PromptModal from "../Components/PromptModal";
import "../css/pages.css";
import RenderAdminPage from "../RenderAdminPage";
import "./SystemUsers.css";

function SystemUsers() {
  const history = useHistory();
  const dispatch = useDispatch();
  const { GetSystemUsers } = bindActionCreators(dataActionCreators, dispatch);
  const {
    AddNewSystemUser,
    ResetAuthResponse,
    DeleteSystemUser,
    EditSystemUser,
  } = bindActionCreators(authActionCreators, dispatch);
  const data = useSelector((state) => state.data);
  const auth = useSelector((state) => state.auth);
  const [openModal, setOpenModal] = useState(false);
  const [openEditModal, setOpenEditModal] = useState(false);
  const [openPromptModal, setPromptOpenModal] = useState(false);
  const initialFormData = {
    name: "",
    email: "",
    staff_code: "",
    phone_number: "",
    password: "",
    super_role: "ADMIN",
    title: "Mr.",
  };

  const initialFormEditData = {
    name: "",
    email: "",
    staff_code: "",
    phone_number: "",
    officer: "",
    super_role: "ADMIN",
  };
  const [formData, setFormData] = useState(initialFormData);
  const [formEditData, setFormEditData] = useState(initialFormEditData);
  const [selectedRoles, setSelectedRoles] = useState([]);
  const [selectedEditUserRoles, setSelectedEditUserRoles] = useState([]);
  const [seletedUserData, setSelectedUserData] = useState({});

  const roles = [];
  console.log('selectedRoles', selectedRoles)
  const rolesValues = [
    "ADMIN",
    "LOAN_OFFICER",
    "LOAN_OFFICER_AUTHORIZER",
    "LOAN_OFFICER_HEAD",
    "MART_OFFICER",
    "UNION_USER",
    "MART_OFFICER_HEAD",
    "INVESTMENT",
    "INVESTMENT_HEAD",
  ];

  console.log("roles", roles);

  const handleChange = (e) => {
    const { name, value } = e.target;
    setFormData({ ...formData, [name]: value });
    console.log("formData", formData);
  };
  const handleFormEditChange = (e) => {
    const { name, value } = e.target;
    setFormEditData({ ...formEditData, [name]: value });
  };


  const handleModalSubmit = (e) => {
    e?.preventDefault();
    // console.log('e', e)
    const newName = `${formData.title} ${formData.name}`;
    console.log("formData", {
      ...formData,
      name: newName,
      user_type: "SYSTEM_USER",
      role: selectedRoles,
      staff_id: formData.staff_code,
    });
    if (formData?.name) {
      AddNewSystemUser({
        ...formData,
        name: newName,
        user_type: "SYSTEM_USER",
        role: selectedRoles,
        staff_id: formData.staff_code,
      });
      setFormData(initialFormData);
      setOpenModal(false);
    }
  };

  const handleEditModalSubmit = (e, user) => {
    e.preventDefault();
    console.log(formEditData);
    console.log("user", user);
    console.log("selectedEditUserRoles", selectedEditUserRoles);
    EditSystemUser(user, {...formEditData, role: selectedEditUserRoles});
    setOpenEditModal(false);
  };

  useEffect(() => {
    setFormEditData({
      ...formEditData,
      name: seletedUserData?.name,
      email: seletedUserData?.email,
      phone_number: seletedUserData?.phone_number,
      staff_code: seletedUserData?.staff_code,
      super_role: seletedUserData?.super_role,
    });
    setSelectedEditUserRoles(seletedUserData?.role)
  }, [seletedUserData]);

  useEffect(() => {
    GetSystemUsers();
  }, []);

  useEffect(() => {
    if (auth?.response?.state === "SUCCESS") {
      toast.success(auth?.response?.message);
      setTimeout(() => {
        ResetAuthResponse();
        GetSystemUsers();
      }, 1500);
    } else if (auth?.response?.state === "ERROR") {
      toast.error(auth?.response?.message);
      setTimeout(() => {
        ResetAuthResponse();
      }, 1500);
    }
  }, [auth?.response?.state, auth?.response?.message]);

  return (
    <div>
      <RenderAdminPage title="System Users">
        {auth.isLoading && <Loader />}
        <div className="flex flex-col sm:flex-row gap-3 mb-6">
          <div className="flex-1">
            <label htmlFor="search" className="block text-sm font-medium text-slate-700 dark:text-slate-300 mb-1">Search</label>
            <input
              type="search"
              id="search"
              placeholder="Search by staff ID, name..."
              className="w-full px-4 py-2.5 rounded-xl border border-slate-200 dark:border-gray-600 bg-white dark:bg-gray-800 text-slate-800 dark:text-slate-200 text-sm focus:ring-2 focus:ring-indigo-500 focus:border-transparent outline-none transition-all placeholder:text-slate-400"
            />
          </div>
          <div className="w-full sm:w-40">
            <label htmlFor="limit" className="block text-sm font-medium text-slate-700 dark:text-slate-300 mb-1">Show</label>
            <select className="w-full px-4 py-2.5 rounded-xl border border-slate-200 dark:border-gray-600 bg-white dark:bg-gray-800 text-slate-800 dark:text-slate-200 text-sm focus:ring-2 focus:ring-indigo-500 focus:border-transparent outline-none transition-all">
              <option value={15}>15</option>
              <option value={25}>25</option>
              <option value={30}>30</option>
              <option value={50}>50</option>
              <option value={100}>100</option>
              <option value={200}>200</option>
              <option value={250}>250</option>
            </select>
          </div>
        </div>

        <div className="flex items-center justify-between mb-4">
          <p className="text-sm text-slate-500 dark:text-slate-400">{data?.system_users?.length || 0} users</p>
          <button
            className="px-4 py-2.5 rounded-xl bg-indigo-600 hover:bg-indigo-700 text-white text-sm font-semibold transition-colors shadow-sm"
            onClick={() => setOpenModal(true)}
          >
            Add Member
          </button>
        </div>

        <div className="bg-white dark:bg-gray-800 rounded-xl shadow-sm border border-slate-200 dark:border-gray-700 overflow-hidden">
          <div className="overflow-x-auto">
            <table className="w-full">
              <thead>
                <tr className="bg-slate-50 dark:bg-gray-700/50">
                  <th className="px-4 py-3 text-left text-xs font-semibold text-slate-500 dark:text-slate-400 uppercase tracking-wider">Name</th>
                  <th className="px-4 py-3 text-left text-xs font-semibold text-slate-500 dark:text-slate-400 uppercase tracking-wider">Email</th>
                  <th className="px-4 py-3 text-left text-xs font-semibold text-slate-500 dark:text-slate-400 uppercase tracking-wider">Phone</th>
                  <th className="px-4 py-3 text-left text-xs font-semibold text-slate-500 dark:text-slate-400 uppercase tracking-wider">Roles</th>
                  <th className="px-4 py-3 text-left text-xs font-semibold text-slate-500 dark:text-slate-400 uppercase tracking-wider">Main Role</th>
                  <th className="px-4 py-3"></th>
                </tr>
              </thead>
              <tbody className="divide-y divide-slate-100 dark:divide-gray-700">
                {data?.system_users?.length > 0 ? (
                  <>
                    {data?.system_users?.map((user, index) => (
                      <tr key={index + 1} className="hover:bg-slate-50 dark:hover:bg-gray-700/30 transition-colors">
                        <td className="px-4 py-3">
                          <div className="flex items-center gap-3">
                            <img className="w-9 h-9 rounded-full object-cover" src={user?.profile_image || (user?.name?.split(" ")[0] === "Mr." ? "/images/dev/avarta2.jpeg" : "/images/dev/woman-avarta.jpeg")} alt="" />
                            <div>
                              <p className="text-sm font-medium text-slate-800 dark:text-slate-200">{user?.name}</p>
                              <p className="text-xs text-slate-500 dark:text-slate-400">{user?.staff_code}</p>
                            </div>
                          </div>
                        </td>
                        <td className="px-4 py-3 text-sm text-slate-700 dark:text-slate-300">{user?.email}</td>
                        <td className="px-4 py-3 text-sm text-slate-700 dark:text-slate-300">{user?.phone_number}</td>
                        <td className="px-4 py-3">
                          <div className="flex flex-wrap gap-1">
                            {user?.role.map((rol, i) => (
                              <span key={i} className="inline-flex px-2 py-0.5 rounded-full text-xs font-medium bg-slate-100 dark:bg-gray-700 text-slate-600 dark:text-slate-300">{rol}</span>
                            ))}
                          </div>
                        </td>
                        <td className="px-4 py-3">
                          <span className="inline-flex px-2.5 py-1 rounded-full text-xs font-semibold bg-indigo-100 dark:bg-indigo-900/30 text-indigo-700 dark:text-indigo-300">{user?.super_role}</span>
                        </td>
                        <td className="px-4 py-3 text-right">
                          <div className="flex items-center justify-end gap-2">
                            <button
                              type="button"
                              className="text-slate-400 hover:text-indigo-600 dark:hover:text-indigo-400 transition-colors"
                              onClick={() => { setOpenEditModal(true); setSelectedUserData(user); }}
                            >
                              <svg className="h-5 w-5 fill-current" viewBox="0 0 24 24"><path d="M12 6a2 2 0 110-4 2 2 0 010 4zm0 8a2 2 0 110-4 2 2 0 010 4zm-2 6a2 2 0 104 0 2 2 0 00-4 0z" /></svg>
                            </button>
                            <button
                              type="button"
                              className="text-slate-400 hover:text-red-600 dark:hover:text-red-400 transition-colors"
                              onClick={() => { setPromptOpenModal(true); setSelectedUserData(user); }}
                            >
                              <svg className="h-5 w-5" fill="none" viewBox="0 0 24 24" stroke="currentColor" strokeWidth="2"><path strokeLinecap="round" strokeLinejoin="round" d="M19 7l-.867 12.142A2 2 0 0116.138 21H7.862a2 2 0 01-1.995-1.858L5 7m5 4v6m4-6v6m1-10V4a1 1 0 00-1-1h-4a1 1 0 00-1 1v3M4 7h16" /></svg>
                            </button>
                          </div>
                        </td>
                      </tr>
                    ))}
                  </>
                ) : (
                  <tr><td colSpan="6" className="px-4 py-12 text-center text-sm text-slate-400 dark:text-slate-500">No data available</td></tr>
                )}
              </tbody>
            </table>
          </div>
        </div>

        {openModal && (
          <Modal
            closeModal={setOpenModal}
            // submitFunction={handleModalSubmit()}
            title={"Add User"}
            width={"50%"}
          >
            <form>
              <div
                className=""
                style={{
                  display: "grid",
                  gridTemplateColumns: "20% 80%",
                  gap: "3px",
                }}
              >
                <div className="superRole">
                  <label
                    htmlFor="super_role"
                    class="block mb-2 text-sm font-medium text-gray-900 dark:text-gray-400"
                  >
                    Title
                  </label>
                  <select
                    id="title"
                    onChange={handleChange}
                    name={"title"}
                    value={formData.title}
                    class="block p-2 mb-6 w-full text-sm text-gray-900 bg-gray-50 rounded-lg border border-gray-300 focus:ring-blue-500 focus:border-blue-500 dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:ring-blue-500 dark:focus:border-blue-500"
                  >
                    <option value="Mr.">Mr.</option>
                    <option value="Miss">Miss</option>
                  </select>
                </div>
                <div>
                  <label
                    for="name"
                    className="block mb-1 text-sm font-medium text-gray-900 dark:text-gray-300"
                  >
                    Full Name
                  </label>
                  <input
                    type="text"
                    id="name"
                    className="bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-blue-500 focus:border-blue-500 block w-full p-2.5 dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:ring-blue-500 dark:focus:border-blue-500"
                    placeholder="John"
                    required
                    value={formData.name}
                    name="name"
                    onChange={handleChange}
                  />
                </div>
              </div>

              <div className="grid gap-6 mb-1 md:grid-cols-2">
                <div>
                  <label
                    for="staff_id"
                    className="block mb-1 text-sm font-medium text-gray-900 dark:text-gray-300"
                  >
                    Staff Code
                  </label>
                  <input
                    type="text"
                    id="staff_id"
                    className="bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-blue-500 focus:border-blue-500 block w-full p-2.5 dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:ring-blue-500 dark:focus:border-blue-500"
                    required
                    name="staff_code"
                    value={formData.staff_code}
                    onChange={handleChange}
                  />
                </div>
                <div>
                  <label
                    for="staff_id"
                    className="block mb-1 text-sm font-medium text-gray-900 dark:text-gray-300"
                  >
                    Officer
                  </label>
                  <input
                    type="text"
                    id="staff_id"
                    className="bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-blue-500 focus:border-blue-500 block w-full p-2.5 dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:ring-blue-500 dark:focus:border-blue-500"
                    required
                    placeholder="North Loan Officer"
                    name="officer"
                    value={formData.officer}
                    onChange={handleChange}
                  />
                </div>
              </div>
              <div className="email_nd_phone grid gap-6 mb-1 md:grid-cols-2">
                <div className="email">
                  <label
                    for="input-group-1"
                    className="block mb-2 text-sm font-medium text-gray-900 dark:text-gray-300"
                  >
                    Your Email
                  </label>
                  <div className="relative mb-1">
                    <div className="flex absolute inset-y-0 left-0 items-center pl-3 pointer-events-none">
                      <svg
                        aria-hidden="true"
                        className="w-5 h-5 text-gray-500 dark:text-gray-400"
                        fill="currentColor"
                        viewBox="0 0 20 20"
                        xmlns="http://www.w3.org/2000/svg"
                      >
                        <path d="M2.003 5.884L10 9.882l7.997-3.998A2 2 0 0016 4H4a2 2 0 00-1.997 1.884z"></path>
                        <path d="M18 8.118l-8 4-8-4V14a2 2 0 002 2h12a2 2 0 002-2V8.118z"></path>
                      </svg>
                    </div>
                    <input
                      type="text"
                      id="input-group-1"
                      className="bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-blue-500 focus:border-blue-500 block w-full pl-10 p-2.5  dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:ring-blue-500 dark:focus:border-blue-500"
                      placeholder="example@gmail.com"
                      name="email"
                      value={formData.email}
                      onChange={handleChange}
                    />
                  </div>
                </div>

                <div>
                  <label
                    for="phone"
                    className="block mb-2 text-sm font-medium text-gray-900 dark:text-gray-300"
                  >
                    Phone number
                  </label>
                  <input
                    type="tel"
                    name="phone_number"
                    id="phone"
                    onChange={handleChange}
                    className="bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-blue-500 focus:border-blue-500 block w-full p-2.5 dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:ring-blue-500 dark:focus:border-blue-500"
                    placeholder=""
                    value={formData.phone_number}
                    pattern="[0-9]{3}-[0-9]{2}-[0-9]{3}"
                    required
                  />
                </div>
              </div>

              <div className="grid gap-6 mb-1 md:grid-cols-2">
               
                <div className="roles">
                  <label
                    for="roles"
                    className="block mb-2 text-sm font-medium text-gray-900 dark:text-gray-300"
                  >
                    Add Roles(who can manage)
                  </label>
                  <div className="rols_chips">
                {rolesValues.map((rol, index) => {
                      return (
                        <div
                          key={index}
                          className="rol_chip"
                          style={{background: selectedRoles.includes(rol) && 'var(--primaryColor)'}}
                          onClick={() => {
                          
                            if(selectedRoles.includes(rol)){
                              
                            const newRols =   selectedRoles.filter(selRol => selRol !== rol)
                              setSelectedRoles(newRols)
                            }else{
                              setSelectedRoles([...selectedRoles, rol])
               
                            }
                            
                          }}
                        >
                          {rol}{" "}
                        </div>
                      );
                    })}
                </div>
                  
                </div>
                <div>
                  <div className="superRole">
                    <label
                      htmlFor="super_role"
                      class="block mb-2 text-sm font-medium text-gray-900 dark:text-gray-400"
                    >
                      Choose Main Role
                    </label>
                    <select
                      id="super_role"
                      onChange={handleChange}
                      name={"super_role"}
                      class="block p-2 mb-6 w-full text-sm text-gray-900 bg-gray-50 rounded-lg border border-gray-300 focus:ring-blue-500 focus:border-blue-500 dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:ring-blue-500 dark:focus:border-blue-500"
                    >
                      <option value="ADMIN">ADMIN</option>
                      <option value="LOAN_OFFICER">LOAN OFFICER</option>
                      <option value="MART_OFFICER">MART OFFICER</option>
                      <option value="UNION_USER">UNION USER</option>
                      <option value="INVESTMENT_OFFICER">
                        INVESTMENT OFFICER
                      </option>
                    </select>
                  </div>
                  <div className="password">
                    <label
                      htmlFor="password"
                      class="block mb-2 text-sm font-medium text-gray-900 dark:text-gray-400"
                    >
                      Default Password
                    </label>
                    <input
                      type="password"
                      id="password"
                      className="bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-blue-500 focus:border-blue-500 block w-full p-2.5 dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:ring-blue-500 dark:focus:border-blue-500"
                      required
                      name="password"
                      value={formData.password}
                      onChange={handleChange}
                    />
                  </div>
                </div>
              </div>

              <div className="modalButton">
                <div className="flex items-center p-6 space-x-2 rounded-b border-t border-gray-200 dark:border-gray-600">
                  <button
                    data-modal-toggle="defaultModal"
                    type="submit"
                    onClick={handleModalSubmit}
                    className="text-white bg-blue-700 hover:bg-blue-800 focus:ring-4 focus:outline-none focus:ring-blue-300 font-medium rounded-lg text-sm px-5 py-2.5 text-center dark:bg-blue-600 dark:hover:bg-blue-700 dark:focus:ring-blue-800"
                  >
                    Continue
                  </button>
                  <button
                    data-modal-toggle="defaultModal"
                    type="button"
                    onClick={() => setOpenModal(false)}
                    className="text-gray-500 bg-white hover:bg-gray-100 focus:ring-4 focus:outline-none focus:ring-blue-300 rounded-lg border border-gray-200 text-sm font-medium px-5 py-2.5 hover:text-gray-900 focus:z-10 dark:bg-gray-700 dark:text-gray-300 dark:border-gray-500 dark:hover:text-white dark:hover:bg-gray-600 dark:focus:ring-gray-600"
                  >
                    Decline
                  </button>
                </div>
              </div>
            </form>
          </Modal>
        )}

        {openEditModal && (
          <Modal
            closeModal={setOpenEditModal}
            // submitFunction={handleModalSubmit()}
            title={"Edit User"}
            width={"50%"}
          >
            {console.log('seletedUserData', seletedUserData)}
            <form autoComplete="false" aria-autocomplete="false">
              <div>
                <label
                  for="name"
                  className="block mb-1 text-sm font-medium text-gray-900 dark:text-gray-300"
                >
                  Full Name
                </label>
                <input
                  type="text"
                  id="name"
                  className="bg-gray-50 mb-2 border border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-blue-500 focus:border-blue-500 block w-full p-2.5 dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:ring-blue-500 dark:focus:border-blue-500"
                  placeholder="John"
                  defaultValue={seletedUserData?.name}
                  name="name"
                  onChange={handleFormEditChange}
                />
              </div>
              <div className="grid gap-6 mb-1 md:grid-cols-2">
                <div>
                  <label
                    for="staff_id"
                    className="block mb-1 text-sm font-medium text-gray-900 dark:text-gray-300"
                  >
                    Staff Code
                  </label>
                  <input
                    type="text"
                    id="staff_id"
                    className="bg-gray-50 mb-3 border border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-blue-500 focus:border-blue-500 block w-full p-2.5 dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:ring-blue-500 dark:focus:border-blue-500"
                    name="staff_code"
                    defaultValue={seletedUserData.staff_code}
                    onChange={handleFormEditChange}
                  />
                </div>
                <div>
                  <label
                    for="staff_id"
                    className="block mb-1 text-sm font-medium text-gray-900 dark:text-gray-300"
                  >
                    Officer
                  </label>
                  <input
                    type="text"
                    id="officer"
                    className="bg-gray-50 mb-3 border border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-blue-500 focus:border-blue-500 block w-full p-2.5 dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:ring-blue-500 dark:focus:border-blue-500"
                    name="officer"
                    defaultValue={seletedUserData.officer}
                    onChange={handleFormEditChange}
                  />
                </div>
              </div>
              <div className="email_nd_phone grid gap-6 mb-1 md:grid-cols-2">
                <div className="email">
                  <label
                    for="input-group-1"
                    className="block mb-2 text-sm font-medium text-gray-900 dark:text-gray-300"
                  >
                    Your Email
                  </label>
                  <div className="relative mb-1">
                    <div className="flex absolute inset-y-0 left-0 items-center pl-3 pointer-events-none">
                      <svg
                        aria-hidden="true"
                        className="w-5 h-5 text-gray-500 dark:text-gray-400"
                        fill="currentColor"
                        viewBox="0 0 20 20"
                        xmlns="http://www.w3.org/2000/svg"
                      >
                        <path d="M2.003 5.884L10 9.882l7.997-3.998A2 2 0 0016 4H4a2 2 0 00-1.997 1.884z"></path>
                        <path d="M18 8.118l-8 4-8-4V14a2 2 0 002 2h12a2 2 0 002-2V8.118z"></path>
                      </svg>
                    </div>
                    <input
                      type="text"
                      id="input-group-1"
                      className="bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-blue-500 focus:border-blue-500 block w-full pl-10 p-2.5  dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:ring-blue-500 dark:focus:border-blue-500"
                      placeholder="example@gmail.com"
                      name="email"
                      defaultValue={seletedUserData.email}
                      onChange={handleFormEditChange}
                    />
                  </div>
                </div>

                <div>
                  <label
                    for="phone"
                    className="block mb-2 text-sm font-medium text-gray-900 dark:text-gray-300"
                  >
                    Phone number
                  </label>
                  <input
                    type="tel"
                    name="phone_number"
                    id="phone"
                    onChange={handleFormEditChange}
                    className="bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-blue-500 focus:border-blue-500 block w-full p-2.5 dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:ring-blue-500 dark:focus:border-blue-500"
                    placeholder=""
                    defaultValue={seletedUserData.phone_number}
                  />
                </div>
              </div>

              <div className="grid gap-6 mb-6 md:grid-cols-2">
                <div className="roles">
                  <label
                    for="roles"
                    className="block mb-2 text-sm font-medium text-gray-900 dark:text-gray-300"
                  >
                    Add Roles
                  </label>
                  <div className="rols_chips">
                {rolesValues?.map((rol, index) => {
                      return (
                        <div
                          key={index}
                          className="rol_chip"
                          style={{background: selectedEditUserRoles?.includes(rol) && 'var(--primaryColor)'}}
                          onClick={() => {
                          
                            if(selectedEditUserRoles?.includes(rol)){
                              
                            const newRols =   selectedEditUserRoles?.filter(selRol => selRol !== rol)
                              setSelectedEditUserRoles(newRols)
                            }else{
                              setSelectedEditUserRoles([...selectedEditUserRoles, rol])
               
                            }
                            
                          }}
                        >
                          {rol}{" "}
                        </div>
                      );
                    })}
                </div>
                 
                </div>
                <div>
                  <div className="superRole">
                    <label
                      htmlFor="super_role"
                      class="block mb-2 text-sm font-medium text-gray-900 dark:text-gray-400"
                    >
                      Choose Main Role
                    </label>
                    <select
                      id="super_role"
                      onChange={handleFormEditChange}
                      name={"super_role"}
                      class="block p-2 mb-6 w-full text-sm text-gray-900 bg-gray-50 rounded-lg border border-gray-300 focus:ring-blue-500 focus:border-blue-500 dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:ring-blue-500 dark:focus:border-blue-500"
                    >
                      <option value="ADMIN">
                        {seletedUserData?.super_role}
                      </option>
                      <option value="ADMIN">ADMIN</option>
                      <option value="LOAN_OFFICER">LOAN OFFICER</option>
                      <option value="MART_OFFICER">MART OFFICER</option>
                      <option value="INVESTMENT_OFFICER">
                        INVESTMENT OFFICER
                      </option>
                    </select>
                  </div>
                  <div className="password">
                    <label
                      htmlFor="password"
                      class="block mb-2 text-sm font-medium text-gray-900 dark:text-gray-400"
                    >
                      Default Password
                    </label>
                    <input
                      type="password"
                      id="password"
                      className="bg-gray-50 border border-gray-300 text-gray-900 text-sm rounded-lg focus:ring-blue-500 focus:border-blue-500 block w-full p-2.5 dark:bg-gray-700 dark:border-gray-600 dark:placeholder-gray-400 dark:text-white dark:focus:ring-blue-500 dark:focus:border-blue-500"
                      name="password"
                      autoComplete="false"
                      // defaultValue={''}
                      onChange={handleFormEditChange}
                    />
                  </div>
                </div>
              </div>

              <div className="modalButton">
                <div className="flex items-center p-6 space-x-2 rounded-b border-t border-gray-200 dark:border-gray-600">
                  <button
                    data-modal-toggle="defaultModal"
                    type="submit"
                    onClick={(e) =>
                      handleEditModalSubmit(e, seletedUserData?._id)
                    }
                    className="text-white bg-green-700 hover:bg-green-800 focus:ring-4 focus:outline-none focus:ring-blue-300 font-medium rounded-lg text-sm px-5 py-2.5 text-center dark:bg-blue-600 dark:hover:bg-blue-700 dark:focus:ring-blue-800"
                  >
                    Save User
                  </button>
                  <button
                    data-modal-toggle="defaultModal"
                    type="button"
                    onClick={() => setOpenEditModal(false)}
                    className="text-gray-500 bg-white hover:bg-gray-100 focus:ring-4 focus:outline-none focus:ring-blue-300 rounded-lg border border-gray-200 text-sm font-medium px-5 py-2.5 hover:text-gray-900 focus:z-10 dark:bg-gray-700 dark:text-gray-300 dark:border-gray-500 dark:hover:text-white dark:hover:bg-gray-600 dark:focus:ring-gray-600"
                  >
                    Decline
                  </button>
                </div>
              </div>
            </form>
          </Modal>
        )}

        {openPromptModal && (
          <PromptModal closeModal={setPromptOpenModal} width={"auto"}>
            <div class="relative  ">
              <div class="p-6 text-center">
                <svg
                  aria-hidden="true"
                  class="mx-auto mb-4 w-14 h-14 text-gray-400 dark:text-gray-200"
                  fill="none"
                  stroke="currentColor"
                  viewBox="0 0 24 24"
                  xmlns="http://www.w3.org/2000/svg"
                >
                  <path
                    stroke-linecap="round"
                    stroke-linejoin="round"
                    stroke-width="2"
                    d="M12 8v4m0 4h.01M21 12a9 9 0 11-18 0 9 9 0 0118 0z"
                  ></path>
                </svg>
                <h3 class="mb-5 text-lg font-normal text-gray-500 dark:text-gray-400">
                  Are you sure you want to delete this {seletedUserData?.name}?
                </h3>
                <button
                  data-modal-toggle="popup-modal"
                  type="button"
                  onClick={() => {
                    DeleteSystemUser(seletedUserData?.staff_code);
                    setPromptOpenModal(false);
                  }}
                  class="text-white bg-red-600 hover:bg-red-800 focus:ring-4 focus:outline-none focus:ring-red-300 dark:focus:ring-red-800 font-medium rounded-lg text-sm inline-flex items-center px-5 py-2.5 text-center mr-2"
                >
                  Yes, I'm sure
                </button>
                <button
                  data-modal-toggle="popup-modal"
                  type="button"
                  class="text-gray-500 bg-white hover:bg-gray-100 focus:ring-4 focus:outline-none focus:ring-gray-200 rounded-lg border border-gray-200 text-sm font-medium px-5 py-2.5 hover:text-gray-900 focus:z-10 dark:bg-gray-700 dark:text-gray-300 dark:border-gray-500 dark:hover:text-white dark:hover:bg-gray-600 dark:focus:ring-gray-600"
                  onClick={() => setPromptOpenModal(false)}
                >
                  No, cancel
                </button>
              </div>
            </div>
          </PromptModal>
        )}

        <ToastContainer autoClose={3000} />
      </RenderAdminPage>
    </div>
  );
}

export default SystemUsers;
